import { useContext } from 'react';
import TabContainer from './TabContainer';
import InvoicesToPayContext from '../contexts/InvoicesToPayContext';
import StepperContext from '../contexts/StepperContext';
import SubscriptionsContext from '../contexts/SubscriptionsContext';
import TabContext from '../contexts/TabContext';
import CustomButton from './CustomButton';
import HelpMessage from './HelpMessage';
import StepperContainer from './StepperContainer';
import { INVOICE_TABS } from '../constants/enums';
import { Box, Tooltip } from '@chakra-ui/react';
import { useBreakpointsContext } from '../hooks/useBreakpointsContext';

const InvoicesTabAndStepperLayout = () => {
  const { isSmallScreen } = useBreakpointsContext();
  const { tabSelected } = useContext(TabContext);

  const MobileLayout = () => {
    const { activeStepContext } = useContext(StepperContext);
    const { activeStep, setActiveStep } = activeStepContext;
    const invoicesToPayCtx = useContext(InvoicesToPayContext);
    const { showSubscriptionOffer, selectedSubscription } = useContext(SubscriptionsContext);

    const isIniciarPagoDisabled =
      invoicesToPayCtx.invoicesToPay.length < 1 || (showSubscriptionOffer && selectedSubscription === null);

    return (
      <>
        {activeStep <= 0 ? <TabContainer /> : <StepperContainer />}
        {activeStep <= 0 && tabSelected === INVOICE_TABS.PENDING && (
          <Tooltip
            label={
              showSubscriptionOffer && selectedSubscription === null
                ? 'Indica si quieres o no recibir beneficios para continuar'
                : undefined
            }
            hasArrow
            placement="top"
          >
            <Box as="span" display="block" mx="auto" width="80%">
              <CustomButton
                py={'6px'}
                mx={'auto'}
                width={'100%'}
                isDisabled={isIniciarPagoDisabled}
                onClick={() => setActiveStep(1)}
              >
                INICIAR PAGO
              </CustomButton>
            </Box>
          </Tooltip>
        )}
        <Box mx="auto">
          <HelpMessage />
        </Box>
      </>
    );
  };

  const DesktopLayout = () => {
    return <TabContainer rightContent={<StepperContainer />} />;
  };

  return isSmallScreen ? <MobileLayout /> : <DesktopLayout />;
};

export default InvoicesTabAndStepperLayout;
